import { useState } from 'react';

import { logger } from '~/features/logging/logger';

import { clientHttpTrackEvent } from '../client-http-track-event';
import { httpIdentifyEvent } from '../http-identify-event';
import { AnalyticsEvent } from '../types';

// Used for lead form events going to marketo, or events which require the success/failure state of the event sent to segment.
export function useLeadFormEvent() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function sendSegmentLeadFormEvents({
    identifyTraits,
    trackAnalyticsEvent,
    integrations,
  }: {
    identifyTraits: Record<string, any>;
    trackAnalyticsEvent: AnalyticsEvent;
    integrations?: { sendToSalesforce?: boolean };
  }) {
    try {
      setIsSubmitting(true);

      await httpIdentifyEvent(identifyTraits, integrations);
      const trackEventResponse = await clientHttpTrackEvent(trackAnalyticsEvent, integrations);

      if (!trackEventResponse?.success) {
        throw new Error('Error submitting form.');
      }

      setIsSubmitting(false);
      return { success: true };
    } catch (error) {
      logger.error('Error handling lead form submit response', {
        file: 'src/features/analytics/hooks/use-lead-form-event.ts',
        function: 'sendSegmentLeadFormEvents',
        error: error,
      });

      setIsSubmitting(false);
      return { success: false };
    }
  }
  return { sendSegmentLeadFormEvents, isSubmitting };
}
